import api from 'services/system/user'

export const handleSave = async (values: any) => {
  let res = await api.create(values)

  return res?.data?.success
}
